export { default } from './GatsbyButton';
